import { render, staticRenderFns } from "./windowParamItemData.vue?vue&type=template&id=304933fc&scoped=true&"
import script from "./windowParamItemData.vue?vue&type=script&lang=js&"
export * from "./windowParamItemData.vue?vue&type=script&lang=js&"
import style0 from "./windowParamItemData.vue?vue&type=style&index=0&id=304933fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304933fc",
  null
  
)

export default component.exports